import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=e4931f52&scoped=true&"
import script from "./testIndex.vue?vue&type=script&lang=js&"
export * from "./testIndex.vue?vue&type=script&lang=js&"
import style0 from "./testIndex.vue?vue&type=style&index=0&id=e4931f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4931f52",
  null
  
)

export default component.exports